function getBrandSnippetPrompt(entity, category) {
    return `
            Sei un LLM che descrive il brand ${entity} per la categoria ${category} a un utente. Dammi una frase di 8-10 parole che useresti. Rispondi solo con una struttura JSON come la seguente:
            {
            "data": ["frase"]
            }
            Non includere alcun testo esplicativo prima o dopo il JSON.
            `;
}

function getBrandThemePrompt(entity, category) {
    return `
      Definisci il brand ${entity} per la categoria ${category} usando esattamente 4 parole chiave. Rispondi solo con un oggetto JSON contenente un array di 4 stringhe, seguendo questa struttura precisa:
      {
      "data": ["parolaChiave1", "parolaChiave2", "parolaChiave3", "parolaChiave4"]
      }
      Non includere alcun testo esplicativo prima o dopo il JSON.
      `;
}

function getBrandDescriptionPrompt(entity, category) {
    return `Fornisci una descrizione di 50 parole per ${entity} nella categoria ${category}. Rispondi solo con la descrizione, senza alcuna frase introduttiva o qualificativa.`;
}


function getCategoryPrompt(brand) {
    return `Per il nome del marchio o del prodotto '${brand}', elenca le **5 principali categorie di prodotto ampie** che descrivono il suo segmento di mercato, uso principale o tipologia. **Regole:** - Utilizza solo classificazioni funzionali o di mercato ampie. - Escludi nomi di modelli, nomi di serie, numeri di versione e linee di prodotto. - Le categorie devono essere ampiamente riconosciute senza conoscenze sul marchio. - Concentrati su ruolo, fattore di forma, mercato di riferimento o caratteristiche principali. **Output (rigido):** {"categories": \["Categoria1", "Categoria2", "Categoria3", "Categoria4", "Categoria5"]} Nessuna spiegazione o testo aggiuntivo.`;
}

export {
    getBrandDescriptionPrompt, getBrandSnippetPrompt,
    getBrandThemePrompt, getCategoryPrompt
};

